<template>
    <div class="ag-input-wrapper custom-date-filter" ref="flatpickr">
    <input type='text' data-input />
    <a class='input-button' title='clear' data-clear>
        <i class='fa fa-times'></i>
    </a>
</div>
</template>

<script>
//import flatPickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            date: null
          
        }
    },
     mounted() {
        alert(1);
        this.picker = flatpickr(this.$refs['flatpickr'], {
            onChange: this.onDateChanged.bind(this),
            dateFormat: 'd/m/Y',
            wrap: true
        });

        this.picker.calendarContainer.classList.add('ag-custom-component-popup');
     },
        methods: {
        onDateChanged(selectedDates) {
            this.date = selectedDates[0] || null;
            this.params.onDateChanged();
        },

        getDate() {
            return this.date;
        },

        setDate(date) {
            this.picker.setDate(date);
            this.date = date || null;
        }
    } 
}
</script>

